import { Activity }  from "@druidsoft/botframework-directlinejs";

export const blockingInput_ignorableActivity = (activity: Activity) => {
    return !!activity?.channelData?.inactivityMessage || !!activity?.channelData?.isActivityStatusUpdate;
}

export const ignorableActivity = (activity: Activity) => {
    // to lower case
    const activityName = (activity as any)?.name?.toLowerCase();
    return !!activity?.channelData?.inactivityMessage 
            || activityName === "EnableChat".toLowerCase() 
            || activityName === "Authentication".toLowerCase() 
            || activityName === "LanguageChanged".toLowerCase()
            || activityName === "userAuthenticated".toLowerCase()
            || activity?.type === 'typing'
            ;
}